// extracted by mini-css-extract-plugin
export var box = "Checkbox-module--box--11b9b";
export var checkbox = "Checkbox-module--checkbox--4089d";
export var container = "Checkbox-module--container--e3985";
export var error = "Checkbox-module--error--246b1";
export var input = "Checkbox-module--input--16ebf";
export var optional = "Checkbox-module--optional--000d6";
export var wrapper = "Checkbox-module--wrapper--41726";